import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import { SuggestionProps } from "@tiptap/suggestion";
import Avatar from "@src/lib/ui/Avatar";
import Spacer from "@src/lib/ui/Spacer";
import { cn } from "@src/lib/utils/cn";
import { AtMentionEmployeeFragment } from "@src/features/libraryItem/course/build/comments/mentions/hooks/useMentionConfig.generated";

const MentionList = (
  props: SuggestionProps,
  ref: React.RefObject<HTMLDivElement | null>,
) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const itemRefs = useRef<Array<HTMLDivElement | null>>([]);
  const items = props.items as AtMentionEmployeeFragment[];

  const selectItem = (index: number) => {
    const item = items[index];

    if (item) {
      props.command({ id: item.id, label: item.name });
    }
  };
  useEffect(() => setSelectedIndex(0), [items]);
  useEffect(() => {
    itemRefs.current[selectedIndex]?.scrollIntoView({ block: "nearest" });
  }, [selectedIndex]);
  // @ts-ignore
  useImperativeHandle(ref, () => ({
    // @ts-ignore
    onKeyDown: ({ event }) => {
      if (!items.length) {
        return false;
      }
      if (event.key === "ArrowUp") {
        setSelectedIndex((selectedIndex + items.length - 1) % items.length);
        return true;
      }
      if (event.key === "ArrowDown") {
        setSelectedIndex((selectedIndex + 1) % items.length);
        return true;
      }
      if (event.key === "Enter") {
        selectItem(selectedIndex);
        return true;
      }
      return false;
    },
  }));

  return (
    <div className="max-h-[300px] overflow-y-auto rounded-lg border border-gray-5-alpha bg-white py-1 shadow-[rgb(0_0_0_/_4%)_0px_16px_32px,_rgb(0_0_0_/_4%)_0px_8px_16px,_rgb(0_0_0_/_4%)_0px_4px_8px,_rgb(0_0_0_/_4%)_0px_2px_4px,_rgb(0_0_0_/_4%)_0px_1px_2px]">
      {items.length ? (
        items.map((item, index) => (
          <div
            key={item.id}
            ref={(el) => {
              itemRefs.current[index] = el;
            }}
            className={cn(
              "flex items-center text-sm py-[3px] px-3 font-normal w-[175px] cursor-pointer hover:bg-gray-4-alpha",
              index === selectedIndex && "bg-gray-4-alpha",
            )}
            onClick={() => {
              selectItem(index);
            }}
          >
            <Avatar person={item} size={18} />
            <Spacer size={4} axis={"horizontal"} />
            {item.name}
          </div>
        ))
      ) : (
        <div className="w-[175px] px-3 py-[3px]">No result</div>
      )}
    </div>
  );
};

// @ts-ignore
export default forwardRef(MentionList);
